import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiStar, FiTrendingUp } = FiIcons;

const TeamPerformance = ({ teamMembers }) => {
  const sortedMembers = teamMembers
    .filter(member => member.performance)
    .sort((a, b) => b.performance.score - a.performance.score);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white rounded-xl shadow-sm border border-gray-200 p-6"
    >
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-gray-900">Team Performance</h3>
        <SafeIcon icon={FiTrendingUp} className="w-5 h-5 text-gray-500" />
      </div>

      <div className="space-y-4">
        {sortedMembers.map((member, index) => (
          <motion.div
            key={member.id}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: index * 0.1 }}
            className="flex items-center space-x-4 p-3 rounded-lg hover:bg-gray-50 transition-colors"
          >
            <div className="relative">
              <img
                src={member.avatar}
                alt={member.name}
                className="w-12 h-12 rounded-full"
              />
              {index < 3 && (
                <div className={`absolute -top-1 -right-1 w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold text-white ${
                  index === 0 ? 'bg-yellow-500' : index === 1 ? 'bg-gray-400' : 'bg-amber-600'
                }`}>
                  {index + 1}
                </div>
              )}
            </div>

            <div className="flex-1">
              <div className="flex items-center justify-between">
                <h4 className="font-medium text-gray-900">{member.name}</h4>
                <div className="flex items-center space-x-1">
                  <SafeIcon icon={FiStar} className="w-4 h-4 text-yellow-500" />
                  <span className="text-sm font-medium text-gray-700">
                    {member.performance.avgRating}
                  </span>
                </div>
              </div>
              
              <div className="flex items-center justify-between mt-1">
                <span className="text-sm text-gray-500">{member.department}</span>
                <span className="text-sm text-gray-600">
                  {member.performance.tasksCompleted} tasks completed
                </span>
              </div>

              <div className="mt-2">
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <motion.div
                    initial={{ width: 0 }}
                    animate={{ width: `${member.performance.score}%` }}
                    transition={{ delay: index * 0.2, duration: 0.8 }}
                    className="bg-blue-600 h-2 rounded-full"
                  />
                </div>
                <span className="text-xs text-gray-500 mt-1">
                  Performance Score: {member.performance.score}%
                </span>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default TeamPerformance;